import { render } from "./ModalClose.vue?vue&type=template&id=716d133a"
import script from "./ModalClose.vue?vue&type=script&lang=js"
export * from "./ModalClose.vue?vue&type=script&lang=js"

import "./ModalClose.vue?vue&type=style&index=0&id=716d133a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__